//@config
export default {
  azmoon: {
    question: "v1/question",
    question_id: "v1/question/{0}",
    title: "v1/title",
    option: "v1/option",
    exam_pack_question: "v1/exam_pack/{0}/question",
    exam_pack: "v1/exam_pack",
    exam_pack_all: "v1/exam_pack/all",
    azmoon_execute: "v1/azmoon_execute",
    azmoon_execute_person: "v1/azmoon_execute_person",
    azmoon_execute_person_id: "v1/azmoon_execute_person/{0}",
    azmoon_execute_id_person: "v1/azmoon_execute/{0}/person",
    azmoon_execute_exam_pack: "v1/azmoon_execute/{0}/exam_pack",
    azmoon_execute_exam_pack_requirements:
      "v1/azmoon_execute/{0}/exam_pack/{1}/requirements",
    available_operator: "v1/azmoon_execute/{0}/available_operator",
    exam_pack_children: "v1/exam_pack/{0}/children",
    azmoon_execute_exam_pack_run:
      "v1/azmoon_execute_person/{0}/exam_pack/{1}/run",
    azmoon_execute_exam_pack_questions:
      "v1/azmoon_execute_person/{0}/exam_pack/{1}/question",
    azmoon_execute_answer: "v1/azmoon_execute_person/{0}/answer/{1}",
    azmoon_execute_export: "v1/azmoon_execute/{0}/export",
    available_person: "v1/azmoon_execute/{0}/available_person",
    available_exam_pack: "v1/exam_pack/all",
    exam_pack_clone: "v1/exam_pack/{0}/clone",
    azmoon_execute_person_code_exam_pack_id_status:
      "v1/azmoon_execute_person/{0}/exam_pack/{1}/status",
    azmoon_execute_person_parvandeh:
      "v1/azmoon_execute/{0}/person_parvandeh/{1}",
    azmoon_term_state_id: "v1/azmoon_term_state/{0}",
    azmoon_execute_report: "v1/azmoon_execute/{0}/report",
    rebuildReport: "v1/rebuild-report",
    report_settings: "v1/report_settings",
    report_integrated: "v1/{0}/{1}/report_integrated",
    person_company: "v1/company/{0}/person",
    activity: "v1/{0}/{1}/activity",
    activity_id: "v1/{0}/{1}/activities/{2}",
    exam_pack_questions_order: "v1/exam_pack_questions/order",
    exam_pack_question_order: "v1/exam_pack/{0}/question/{1}",
    state_group: "v1/state_group",
    state_define: "v1/state_define",
    action: "v1/action",
    person: "v1/person",
    company_combo: "v1/company/combo",
    research_plan: "v1/research_plan",
    enum_question_kind: "v1/enum/question_kind",
    attachment_download: "v1/attachment/download",
    evidence_order: "v1/evidence/order",
    azmoon_execute_exam_packs_order: "v1/azmoon_execute_exam_packs/order",
    exam_pack_order: "v1/exam_pack/order",
    form: {
      labelCol: 12,
      textareaRows: 1,
    },
    exam_pack_export: "v1/exam_pack/{0}/export",
    exam_pack_import: "v1/exam_pack/import",
    term_parvandeh_combo: "v1/term_parvandeh_combo",
    term_parvandeh_combo_define: "v1/term_state_combo",
    term_combo: "v1/term_combo",
    term_state_combo: "v1/term_state_combo",
    person_combo: "v1/person-combo",
    question_id_clone: "v1/question/{0}/clone",
    term_state_execute: "v1/term_state_execute",
    analysis_algorithm: "v1/analysis_algorithm",
    analysis_algorithm_id: "v1/analysis_algorithm/{0}",
    analysis_algorithm_combo: "v1/analysis_algorithm_combo",
    algorithm_component: "v1/algorithm_component",
    algorithm_component_id: "v1/algorithm_component/{0}",
    rank_group_combo: "v1/rank_group_combo",
    calculate_karnameh: "v1/calculate_karnameh/{0}",
    azmoon_execute_import_person: "v1/azmoon_execute/{0}/import_person",
    azmoon_execute_exam_pack_show_name: "v1/azmoon_execute/{0}/exam_pack/{1}",
    azmoon_execute_person_show_time_control:
      "v1/azmoon_execute_person/{0}/show_time_control",
    azmoon_execute_time_id: "v1/azmoon_execute_time/{0}",
    exam_pack_all_question: "v1/exam_pack/{0}/all_question",
    exam_pack_control_finish:
      "v1/azmoon_execute_person/{0}/exam_pack/{1}/control_finish",
    exam_pack_import_answers:
      "v1/azmoon_execute/{0}/exam_pack/{1}/import_answers",
    exam_pack_make_report: "v1/azmoon_execute/{0}/exam_pack/{1}/make_report",
    azmoon_execute_exam_pack_requirement:
      "v1/azmoon_execute/{0}/exam_pack/{1}/requirement",
    azmoon_execute_id: "v1/azmoon_execute/{0}",
    azmoonExecutePersonSetAbsent: "v1/azmoon-execute-person/{0}/set-absent",
    rebuildAllAzmoonReports: "v1/rebuild-all-azmoon-reports",
  },
};
